import { filterActiveMuseums, filterExhibitionMuseumsWithLocation } from '@/components/shared/map-stats/MapStats.utils';
import classNames from 'classnames';
import styles from './MapStats.module.scss';
import MapStatsItem from '../../../shared/map-stats/MapStatsItem';
import { FC } from 'react';
import { MuseumCollectionDocument } from '@/interfaces/IMuseumResource';
import { useTranslation } from 'next-i18next';

export interface IMapStatsVisitProps {
	museums?: MuseumCollectionDocument['data'];
	pastMuseums?: MuseumCollectionDocument['meta'];
	currentMuseums?: MuseumCollectionDocument['data'];
	className?: string;
}

export const MapStatsVisit: FC<IMapStatsVisitProps> = (props) => {
	const { t } = useTranslation();
	const { museums = [], pastMuseums = [], currentMuseums = [] } = props;

	const activeMuseums = filterActiveMuseums(museums);
	const currentExhibitions = filterExhibitionMuseumsWithLocation(currentMuseums);

	const mapStatsClassNames = classNames(styles.mapStats, props.className);

	return (
		<div className={mapStatsClassNames}>
			<MapStatsItem
				label={t('museums')}
				count={activeMuseums.length}
				loaded={true}
				icon={'/assets/icons/poi-museum.svg'}
			/>
			<MapStatsItem
				label={t('current-exhibitions')}
				count={currentExhibitions.length}
				loaded={true}
				icon={'/assets/icons/poi-exhibition-current.svg'}
			/>
			<MapStatsItem
				label={t('past-exhibitons')}
				count={pastMuseums.totalCount}
				loaded={true}
				icon={'/assets/icons/poi-exhibition-past.svg'}
			/>
		</div>
	);
};
